export default __webpack_public_path__ + "static/man-default1-89fd64a254614e4fd48a25efc64f4e83.png";